import React, { useState } from 'react';
import { Button } from './Button';
import { MenuIcon, XIcon } from 'lucide-react';
const navLinks = [{
  label: 'LWC Academy',
  href: 'https://schallercoaching.com/lwca'
}, {
  label: 'Coaching',
  href: 'https://schallercoaching.com/lcc'
}, {
  label: 'About Me',
  href: 'https://schallercoaching.com/about'
}];
export function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  return <>
      {/* Premium gold accent line at top */}
      <div className="fixed top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-gold/60 via-gold to-gold/60 z-[60]" data-id="element-220" />

      <nav className="fixed top-[3px] left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-warm-border z-50" data-id="element-221">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between" data-id="element-222">
          {/* Logo */}
          <a href="https://schallercoaching.com/" className="flex items-center gap-3 hover:opacity-80 transition-opacity duration-300" data-id="element-223">
            <img src="https://cdn.magicpatterns.com/uploads/85VKEkAup8hup4hJC5bcru/Greg_logo.png" alt="Schaller Coaching Logo" className="h-10 w-10 object-contain" data-id="element-224" />
            <span className="hidden md:inline font-heading font-bold text-navy text-lg tracking-tight" data-id="element-225">
              Schaller Coaching
            </span>
          </a>

          {/* Desktop nav links + CTA */}
          <div className="hidden md:flex items-center gap-8" data-id="element-226">
            {navLinks.map(link => <a key={link.label} href={link.href} className="font-heading font-medium text-[14px] text-charcoal hover:text-navy transition-colors duration-300" data-id="element-227">
                {link.label}
              </a>)}
            <Button variant="primary" className="text-[14px] px-[28px] py-[14px]" data-id="element-228">
              Schedule a Conversation
            </Button>
          </div>

          {/* Mobile: CTA + hamburger */}
          <div className="flex md:hidden items-center gap-3" data-id="element-229">
            <a href="https://api.leadconnectorhq.com/widget/booking/VHdKXbV72iB8LTpEH0sJ" className="font-heading text-[12px] font-medium px-4 py-2.5 rounded-[6px] bg-navy text-white hover:bg-navy-dark whitespace-nowrap inline-flex items-center justify-center transition-colors duration-300" data-id="element-230">
              Schedule a Conversation
            </a>
            <button onClick={() => setMobileOpen(!mobileOpen)} className="w-10 h-10 flex items-center justify-center text-navy" aria-label="Toggle menu" data-id="element-231">
              {mobileOpen ? <XIcon size={22} data-id="element-232" /> : <MenuIcon size={22} data-id="element-233" />}
            </button>
          </div>
        </div>

        {/* Mobile dropdown */}
        {mobileOpen && <div className="md:hidden bg-white border-t border-warm-border px-6 pb-5 pt-3" data-id="element-234">
            {navLinks.map(link => <a key={link.label} href={link.href} className="block font-heading font-medium text-[15px] text-charcoal hover:text-navy py-3 border-b border-warm-border/50 last:border-0 transition-colors duration-300" onClick={() => setMobileOpen(false)} data-id="element-235">
                {link.label}
              </a>)}
          </div>}
      </nav>
    </>;
}